import { NgModule } from '@angular/core';
import { TitleRegistrationCustomerService } from './titleregistration-customer.service';
import { IndividualDetailService } from '../../customer/detail/individual-detail.service';
import { OrganizationDetailService } from '../../customer/detail/organization-detail.service';

@NgModule({
    providers: [
        TitleRegistrationCustomerService,
        IndividualDetailService,
        OrganizationDetailService,
    ]
})
export class TitleRegistrationCustomerServiceModule {
}
